import { fetchXCoverQuote } from "./xcover.api.js";
import { getCostFromCurrencyString } from "../../utils/general-utils.js";
import { qs, qsAll, elById } from "../../utils/dom.js";
import { toggle } from "../../utils/ui-helpers.js";
import { addAction } from "../../actions/action-config.js";


const XCOVER_PANEL_TEMP_ID = 'atb-xcover-select-template';


export async function getQuote() {
    // run the quote again

    // TODO: set-up function, but will need to go into state
    const response = await fetchXCoverQuote();
    const { costData, quoteData } = response.data;    

    renderQuotePanel(quoteData);

    return quoteData;
}


export function attachXCoverRadioHandler(universalEventHandlerFunc) {
    document.addEventListener('click', (e) => {
        const radio = e.target.closest('input[data-input="xcover"][type="radio"]');
        if (!radio) return;

        universalEventHandlerFunc(radio);
    });
}


/**
 * Does initial set-up of the XCover UI by cloning the template and appending it to the container
 * @param {*} containerEl 
 */

// TODO: set-up function, not needed in "action" register
function setupSelectPanel(containerEl) {
    const xcoverSelectTemplate = document.getElementById(XCOVER_PANEL_TEMP_ID);
    const templateClone        = xcoverSelectTemplate.content.cloneNode(true);

    containerEl.appendChild(templateClone);
}

// DISPLAY FUNCTIONS
function renderQuotePanel(quoteData) {
    qs('.booking-protect-sales-message')?.remove();
    qs('.atb-xcover-extra-wrapper')?.remove();

    // Render the Select Radio panel if the quote is available
    if (quoteData.canProtectBooking) {
        toggle(elById('atb-cancellation-insurance-quote-apology'), false);
        toggle(elById('atb-cancellation-insurance'), true);

        setupSelectPanel(elById('atb-xcover-mount-point'), quoteData.premium);    
        updateQuotePanel(quoteData);
    } else // Otherwise, show a panel explaining the quote is unavailable
        renderZeroPremiumPanel();
}

function updateQuotePanel(quoteData) {
    qs('#atb-refund-protection-terms-frame')
        .src = `https://docs.google.com/gview?url=${quoteData.termsUrl}&embedded=true`;

    // Remove the currency symbol from the premium
    const premium = getCostFromCurrencyString(quoteData.premium);

    // Store the value temporarily 
    const hiddenPremiumInput  = qs('#atb-premium-input');
    const termsUrlLink        = qs('#atb-cancellation-insurance-terms-url');
    const quotePremiumEls     = qsAll('.atb-cancellation-insurance-premium');
    
    quotePremiumEls.forEach(el => {
        el.innerHTML = quoteData.premium;
    });

    if (hiddenPremiumInput) hiddenPremiumInput.value = premium;
    if (termsUrlLink) termsUrlLink.href              = quoteData.termsUrl;

    qs('#atb-refund-protection-terms-url').href = quoteData.termsUrl;
}


function renderZeroPremiumPanel() {
    toggle(qs('.atb-cancellation-insurance'), false);
    toggle(qs('#atb-cancellation-insurance-quote-panel'), false);
    toggle(qs('#atb-cancellation-insurance-quote-apology'), true);
}


// TODO: function I wrote for refreshing XCover quote anytime a cost-affecting action is executed but it's too slow
// so not using it for now
// Also this is an XCover function that relies heavily on utilities inside of this function
async function refreshRefundQuote(actionCtx, getBookingStateProp, runAction) {
    const useBookingProtect = getBookingStateProp('use_booking_protect');
    const hasRunQuote       = getBookingStateProp('has_run_refund_quote');
    const costAffectActions  = [ 'party', 'addon' ];
    const removeQuoteActions = [ 'site', 'category', 'unit', 'sub_unit' ];

    const requestObj = {
        addon_id: '', // custom extras have no ID because they don't exist in the database
        addon_value: 0,
        custom_type: 'xcover',
        custom: 1
    };

    // If the booking is using booking protect, remove it if we're running any of the actions in removeQuote
    if (hasRunQuote && removeQuoteActions.includes(actionCtx.inputId)) {
        const setResponse = await runAction('xcover', 'fetch', {value: '', data: requestObj});
        runAction('xcover', 'set',    { value: requestObj, data: setResponse });
        runAction('xcover', 'render', { value: requestObj, data: setResponse });
        return actionCtx;
    }

    console.log(costAffectActions, actionCtx)
    if (!costAffectActions.includes(actionCtx.inputId))
        return actionCtx;

    if (useBookingProtect) {
        requestObj['addon_value'] = 1;
        
        await getQuote();

        const setResponse = await runAction('xcover', 'fetch', {value: '', data: requestObj});

        actionCtx.data = setResponse;
        runAction('xcover', 'set',    { value: requestObj, data: setResponse });
        runAction('xcover', 'render', { value: requestObj, data: setResponse });    
    }

    return actionCtx;
}